// src/utils/api.js
import axios from "axios";


// Are we in development (CRA sets this)?
const isDev = process.env.NODE_ENV === "development";

let API_BASE;

// 🧪 DEV: auto-detect backend using current hostname (works for localhost & 192.168.x.x)
if (isDev) {
  const host = window.location.hostname; // e.g. "localhost" or "192.168.1.136"
  API_BASE = `http://${host}:5000`;
} else {
  // 🌍 PROD: respect env, fallback to same origin
  API_BASE =
    process.env.REACT_APP_API_URL || `${window.location.origin.replace(/\/$/, "")}`;
}

console.log("🔗 API Base URL:", API_BASE);

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

export default api;

